const BoardMember = ({ role, name }) => (
  <div>
    <p className="text-sm font-semibold text-sky-700 uppercase tracking-wider">
      {role}
    </p>
    <p className="text-xl font-medium text-slate-800">{name}</p>
  </div>
);

function Editorial() {
  return (
    <section id="editorial" className="bg-white py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-sky-900 tracking-tight">
            Editorial Board
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-600">
            Our journal is guided by a dedicated team of editors and advisors.
          </p>
        </div>

        <div className="space-y-10">
          {/* Top-level Roles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-center">
            <div className="sm:col-span-2 lg:col-start-2">
              <BoardMember role="Editor-in-Chief" name="Dr. Rasid M. Paca" />
            </div>
          </div>

          {/* Other Roles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10 text-center">
            <BoardMember
              role="Associate Editor"
              name="Dr. Anabelie V. Valdez"
            />
            <BoardMember
              role="Managing Editor"
              name="Dr. Abdulhaq R. Ditucalan, H.C."
            />
            <BoardMember role="Web Developer" name="Mellhabib M. Angni" />
          </div>

          {/* Grouped Roles */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10 pt-6 border-t border-slate-200">
            <div className="space-y-4 text-center">
              <h3 className="text-sm font-semibold text-sky-700 uppercase tracking-wider">
                Advisory Board
              </h3>
              <p className="text-xl font-medium text-slate-800">
                Dr. Shahid Q. Manalundong
              </p>
              <p className="text-xl font-medium text-slate-800">
                Dr. Jawad Z. Salic
              </p>
            </div>
            <div className="space-y-4 text-center">
              <h3 className="text-sm font-semibold text-sky-700 uppercase tracking-wider">
                Assistant Editors
              </h3>
              <p className="text-xl font-medium text-slate-800">
                Johara C. Bayabao
              </p>
              <p className="text-xl font-medium text-slate-800">
                Mellhabib M. Angni
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Editorial;
